import React, { useState } from 'react'
import { useStaticDataStore } from '../../stores/staticData';
import dummyFounder from '../../assets/images/dummyFounder.png'
const CoFounderTab = ({ getFounder, coFounderData }) => {
    const { data: staticData } = useStaticDataStore();

    let university = [];
    if (staticData?.university?.length) {
        university = staticData?.university;
    }
    let startupRole = [];
    if (staticData?.startupRole?.length) {
        startupRole = staticData?.startupRole;
    }
    return (
        <div className='founder-edit-section'>
            <div className='founder-details'>
                {
                    coFounderData?.map((founder, index) => {
                        return (
                            <>
                                <div className='founder-count'>Co-founder #{index + 2}</div>
                                <div className='founder-dummy-image'>
                                    <img src={coFounderData?.profileImg || dummyFounder} alt="founder dummy image" />
                                </div>
                                <div className='founder-detail-section'>
                                    <div>
                                        <span className='label'>Full name</span>
                                        <div className='value'>{founder?.name}</div>
                                    </div>
                                    <div>
                                        <span className='label'>Option</span>
                                        <div className="value">
                                            {founder?.university?.map((key, idx) => {
                                                const matched = university?.find(item => item?.key === key);
                                                return (
                                                    <span key={key}>
                                                        {matched?.value || key}
                                                        {idx < founder?.university?.length - 1 ? ', ' : ''}
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <span className='label'>Role in startup</span>
                                        <div className="value">
                                            {
                                                staticData?.startupRole?.find(item => item.key === founder?.role)?.value
                                                || founder?.role
                                            }
                                        </div>
                                    </div>
                                    <div>
                                        <span className='label'>LinkedIn profile</span>
                                        <div className='value'>{founder?.linkedInUrl}</div>
                                    </div>
                                    <div>
                                        <span className='label'>Short bio</span>
                                        <div className='value'>{founder?.about}</div>
                                    </div>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default CoFounderTab